/* eslint-disable no-undef */
export default ($) => {
	window.uniqueTrackNames = [];

	const getArticle = () => {
		if (window.location.href.indexOf('embracing-sustainability') > -1) {
			return 'af1';   
		}

		if (window.location.href.indexOf('industries-future') > -1) {
			return 'af2';   
		}

		if (window.location.href.indexOf('smart-life') > -1) {
			return 'af3';   
		}
		return 'hub';
	};

	document.body.addEventListener('progress-25', function(e) {
		if (getArticle() !== 'hub' && $('.nav-point.is-active').length) {
			UniqueScrollTrack('2023-fbcci-' + getArticle() + '-progress-25');
		}
	});

	document.body.addEventListener('progress-50', function(e) {
		if (getArticle() !== 'hub' && $('.nav-point.is-active').length) {
			UniqueScrollTrack('2023-fbcci-' + getArticle() + '-progress-50');
		}
	});

	document.body.addEventListener('progress-75', function(e) {
		if (getArticle() !== 'hub' && $('.nav-point.is-active').length) {
			UniqueScrollTrack('2023-fbcci-' + getArticle() + '-progress-75');
		}
	});

	document.body.addEventListener('progress-100', function(e) {
		if (getArticle() !== 'hub' && $('.nav-point.is-active').length) {
			UniqueScrollTrack('2023-fbcci-' + getArticle() + '-progress-100');
		}
	});

	document.body.addEventListener('data-analytics', function(e) {
		UniqueScrollTrack(e.detail);
	});


	$('body').on('click', '[data-analytics]', function() {
		UniqueScrollTrack($(this).attr('data-analytics').replace('{0}', getArticle()).replace('{1}', window.innerWidth < 1023 ? '-mobile' : ''));
	});

	if (getArticle() === 'hub') {
		setTimeout(() => {
			UniqueScrollTrack('2023-fbcci-hub-hero');
		}, 1000);
	}
	if (window.innerWidth < 1023) {
		const scroller = $('[data-articles-container]');
		scroller.on('scroll', () => {

			const height = scroller[0].clientHeight;
			const scrollHeight = scroller[0].scrollHeight - height;
			const scrollTop = scroller[0].scrollTop;
			const progress = Math.floor(scrollTop / scrollHeight * 100);

			if (progress > 30) {
				document.body.dispatchEvent(new CustomEvent('progress-25', { detail: this }));
			}
			if (progress > 50) {
				document.body.dispatchEvent(new CustomEvent('progress-50', { detail: this }));
			}
			if (progress > 75) {
				document.body.dispatchEvent(new CustomEvent('progress-75', { detail: this }));
			}
			if (progress > 95) {
				document.body.dispatchEvent(new CustomEvent('progress-100', { detail: this }));
			}
		});
	}

	setInterval(() => {
		if ($('video:not([data-analytics-subscribed])').length) {
			$('video:not([data-analytics-subscribed])').on('timeupdate', function() {
				const currentTime = this.currentTime;
				const percent = (currentTime/this.duration);
				const tag = $(this).attr('data-analytics-video');
				if (uniqueTrackNames.indexOf(tag+'0') === -1 && percent > 0.001) {
					playedVideoTracking(tag);
					uniqueTrackNames.push(tag+'0');
				}
				if (uniqueTrackNames.indexOf(tag+'10') === -1 && percent >= 0.1) {
					tenPlayedVideoTracking(tag);
					uniqueTrackNames.push(tag+'10');
				}
				if (uniqueTrackNames.indexOf(tag+'25') === -1 && percent >= 0.25) {
					twentyFivePlayedVideoTracking(tag);
					uniqueTrackNames.push(tag+'25');
				}
				if (uniqueTrackNames.indexOf(tag+'50') === -1 && percent >= 0.5) {
					fiftyPlayedVideoTracking(tag);
					uniqueTrackNames.push(tag+'50');
				}
				if (uniqueTrackNames.indexOf(tag+'75') === -1 && percent >= 0.75) {
					seventyFivePlayedVideoTracking(tag);
					uniqueTrackNames.push(tag+'75');
				}      
				if (uniqueTrackNames.indexOf(tag+'100') === -1 && percent > 0.90) {
					endVideoTracking(tag);
					uniqueTrackNames.push(tag+'100');
				}
			});
			$('video:not([data-analytics-subscribed])').attr('data-analytics-subscribed', true);
		}
	}, 500);
                    
	function playedVideoTracking(title) {
		s.events = 'event32';
		s.prop29 = title;
		s.eVar41 = 'D=c29';
		s.tl(true, 'o', 'cnnadfeaturevideo:play');
		s.events = s.prop29 = s.eVar41 = '';
	}
                    
	function tenPlayedVideoTracking(title) {
		s.events = 'event40,event36';
		s.prop29 = title;
		s.eVar41 = 'D=c29';
		s.tl(true, 'o', 'cnnadfeaturevideo:milestone - video 10% complete');
		s.events = s.prop29 = s.eVar41 = s.products = '';
	}
                    
                    
                    
	function twentyFivePlayedVideoTracking(title) {
		s.events = 'event41,event36';
		s.prop29 = title;
		s.eVar41 = 'D=c29';
		s.tl(true, 'o', 'cnnadfeaturevideo:milestone - video 25% complete');
		s.events = s.prop29 = s.eVar41 = s.products = '';
	}

	function fiftyPlayedVideoTracking(title) {
		s.events = 'event2,event36';
		s.prop29 = title;
		s.eVar41 = 'D=c29';
		s.tl(true, 'o', 'cnnadfeaturevideo:milestone - video 50% complete');
		s.events = s.prop29 = s.eVar41 = s.products = '';
	}
                
	function seventyFivePlayedVideoTracking(title) {
		s.events = 'event42,event36';
		s.prop29 = title;
		s.eVar41 = 'D=c29';
		s.tl(true, 'o', 'cnnadfeaturevideo:milestone - video 75% complete');
		s.events = s.prop29 = s.eVar41 = s.products = '';
	}

	function endVideoTracking(title) {
		s.events = 'event33,event36';
		s.prop29 = title;
		s.eVar41 = 'D=c29';
		s.tl(true, 'o', 'cnnadfeaturevideo:complete');
		s.events = s.prop29 = s.eVar41 = s.products = '';
	}
                        
	function UniqueScrollTrack(text) {
		if (uniqueTrackNames.indexOf(text) == -1) {
			uniqueTrackNames.push(text);
			scrollTrack(text, text);
		}
	}
                        
	function scrollTrack(text, customlink) {
		if (typeof(s) !== 'undefined' && s) {
			s.events = 'event76';
			s.prop69 = text;
			s.eVar69 = 'D=c69';
			s.pageURL = window.location.href;
			s.tl(true, 'o', customlink);
			s.prop69 = s.eVar69 = s.events = '';
		}
	}
};